/* global Promise */
import * as R from 'ramda';
import angular from 'angular';


export default function EditCustomRiskControlDialogController(
  $scope,
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
  vmSharedModelService,
  editCustomRiskControlQuestionDialog
) {
  const vm = this;

  vm.newCustomRiskControl = { ...vm.customRiskControl };
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleAddChildQuestion = _handleAddChildQuestion;
  vm.handleEditRiskControlQuestion = _handleEditRiskControlQuestion;
  vm.handleDeleteRiskControlQuestion = _handleDeleteRiskControlQuestion;
  vm.handleEditCustomRiskControlFormSubmit = _handleEditCustomRiskControlFormSubmit;

  /** ********************************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleAddChildQuestion($event, parentRiskControlQuestion) {
    if ($scope.editCustomRiskControlForm.$invalid) {
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return _saveCustomRiskControl()
      .then(() => {
        loaderService.showViewLoader = false;
        return _showEditCustomRiskControlQuestionDialog($event, {
          customRiskControl: vm.customRiskControl,
          parentRiskControlQuestion: null,
          riskControlQuestion: {
            riskControlId: vm.newCustomRiskControl.riskControlId,
            parentRiskControlQuestionId: parentRiskControlQuestion.riskControlQuestionId,
            riskControlQuestionId: -1,
          },
          addCallback: _handleAddedQuestion
        });
      });
  }

  function _handleEditRiskControlQuestion($event, riskControlQuestion) {
    return _showEditCustomRiskControlQuestionDialog($event, {
      customRiskControl: vm.customRiskControl,
      parentRiskControlQuestion: null,
      riskControlQuestion,
      addCallback: null
    });
  }

  function _handleDeleteRiskControlQuestion($event, riskControlQuestion) {
    ssDialogService.dialogs.vendorManagement.deleteRiskControlQuestionConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Risk Control Question?',
        message: 'Are you sure you want to delete the Risk Control Question?"',
        handleYesClick() {
          _handleConfirmDelete(riskControlQuestion);
        },
        handleNoClick: _closeDeleteRiskControlQuestionDialog,
      })
    );
    return ssDialogService.show(
      ssDialogService.dialogs.vendorManagement.deleteRiskControlQuestionConfirmDialog
    );
  }

  function _handleEditCustomRiskControlFormSubmit($event) {
    if ($scope.editCustomRiskControlForm.$invalid) {
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return _saveCustomRiskControl()
      .then(() => {
        loaderService.showViewLoader = false;
        if (vm.submitType === 'addQuestion') {
          _setFormUnsubmitted();
          return _showEditCustomRiskControlQuestionDialog($event, {
            customRiskControl: vm.customRiskControl,
            parentRiskControlQuestion: null,
            riskControlQuestion: {
              riskControlId: vm.newCustomRiskControl.riskControlId,
              riskControlQuestionId: -1,
            },
            addCallback: _handleAddedQuestion,
          });
        }
        // submitType is 'save'
        return _closeDialog();
      });
  }

  /** ********************************************************
   * Private Functions
   */

  function _setFormUnsubmitted() {
    $scope.editCustomRiskControlForm.$setPristine();
    $scope.editCustomRiskControlForm.$setUntouched();
  }

  function _handleAddedQuestion(riskControlQuestion) {
    vm.customRiskControl.riskControlQuestions = vm.customRiskControl.riskControlQuestions || [];
    vm.customRiskControl.riskControlQuestions.push(riskControlQuestion);
    if (vm.customRiskControl.riskControlQuestions.length > 1) {
      vm.customRiskControl.riskControlQuestions = vmSharedModelService
        .sort(vm.customRiskControl.riskControlQuestions, 'sortOrder');
    }
  }

  function _handleDeletedQuestion(riskControlQuestion) {
    if (!riskControlQuestion) return;
    vm.newCustomRiskControl.riskControlQuestions.splice(
      vm.newCustomRiskControl.riskControlQuestions.indexOf(riskControlQuestion), 1
    );
  }

  function _handleConfirmDelete(riskControlQuestion) {
    loaderService.showViewLoader = true;
    return vmDataService.deleteCustomRiskControlQuestion(riskControlQuestion.riskControlQuestionId)
      .then(() => {
        alerts.success('The custom Risk Control Question has been successfully deleted.');
        _handleDeletedQuestion(riskControlQuestion);
        _closeDeleteRiskControlQuestionDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the custom risk control question.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _showEditCustomRiskControlQuestionDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editCustomRiskControlQuestionDialog = ssDialogService.alert(
      editCustomRiskControlQuestionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editCustomRiskControlQuestionDialog);
  }

  function _saveCustomRiskControl() {
    const isNew = vm.newCustomRiskControl.riskControlId < 0;

    if (!isNew && angular.equals(vm.customRiskControl, vm.newCustomRiskControl)) {
      // No need to save
      return Promise.resolve();
    }
    return vmDataService.saveCustomRiskControl(
      vm.newCustomRiskControl
    )
      .then((response) => {
        angular.extend(vm.newCustomRiskControl, response.data);
        if (R.isNil(vm.newCustomRiskControl.riskControlQuestions)) {
          vm.newCustomRiskControl.riskControlQuestions = [];
        }
        angular.extend(vm.customRiskControl, vm.newCustomRiskControl);
        if (isNew) {
          vm.settings.customRiskControls.push(vm.customRiskControl);
        }
        vm.settings.customRiskControls = R.sortBy(
          R.prop('name'),
          vm.settings.customRiskControls
        );
      });
  }

  function _closeDeleteRiskControlQuestionDialog() {
    return ssDialogService.hide(
      ssDialogService.dialogs.vendorManagement.deleteRiskControlQuestionConfirmDialog
    );
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editCustomRiskControlDialog);
  }
}

EditCustomRiskControlDialogController.$inject = [
  '$scope',
  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'userService',
  'vmDataService',
  'vmSharedModelService',
  'editCustomRiskControlQuestionDialog',
];
